import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import template from './topDefectsReport.tpl.html';
import {StateParams} from "../../common";
import {States} from "../../shared/config/constant.module";
import {apsEnums} from "../../shared/dto/aps.enums";
import {ICommonQueryingReport} from "./commonQueryingReport";
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import ReportServiceName, {ReportService} from "../../services/reports/report.service";
import DateUtilityService from "../../services/utility/dateutility.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";

let requires = [UIUtilityServiceName, LoaderServiceName, ReportServiceName, NavigationServiceName];

export interface TopDefectsReportParams extends StateParams {
  reportPlantId: string;
  reportShopId: string;
  startDate: string;
  endDate: string;
  defectTypeId: string;
  filter: apsEnums.TopDefectsFilter;
  autoRun: boolean;
}

interface TopDefectsReportController extends ICommonQueryingReport {
  plants: Plant[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  startDate: Date;
  endDate: Date;
  filter: apsEnums.TopDefectsFilter;
  filters: EnumOption[];
  uiStartDate: Date;
  uiEndDate: Date;

  reportStartDate: Date;
  reportEndDate: Date;
  reportShopId: string;
  reportShopName: string;
  reportTimeZoneId: string;

  form: angular.IFormController;

  updatePlant(): void;
  formatTime(time: Date): string;
  generateReport(): void;
  generateDetailReport(defect: apsViewModels.TopNDefectReportItem): angular.IPromise<any>;

  defects: apsViewModels.TopNDefectReportItem[];
  searchPerformed: boolean;
  detailResults: apsViewModels.DropReportDetails;
  reportDefect: apsViewModels.TopNDefectReportItem;

  scopeWorkaround: any;
  getDefectDetailsColor(): string;

  requirePlantSelection: boolean;
  requireShopSelection: boolean;
}

class TopDefectsReportCtrl implements TopDefectsReportController {
  plants: Plant[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  startDate: Date;
  endDate: Date;
  filter: apsEnums.TopDefectsFilter;
  filters: EnumOption[];
  uiStartDate: Date;
  uiEndDate: Date;

  reportStartDate: Date;
  reportEndDate: Date;
  reportShopId: string;
  reportShopName: string;
  reportTimeZoneId: string;
  reportFilter: apsEnums.TopDefectsFilter;

  form: any;

  defects: apsViewModels.TopNDefectReportItem[];
  searchPerformed: boolean;
  detailResults: apsViewModels.DropReportDetails;
  reportDefect: apsViewModels.TopNDefectReportItem;

  loaderService: LoaderService;
  reportService: ReportService;
  uiUtilityService: UIUtilityService;
  $anchorScroll: angular.IAnchorScrollService;
  $location: angular.ILocationService;
  $state: angular.ui.IStateService;
  $stateParams: TopDefectsReportParams;

  scopeWorkaround: any;

  requirePlantSelection: boolean;
  requireShopSelection: boolean;
  private $q: angular.IQService;

  constructor(
    navigationService: NavigationService,
    reportService: ReportService,
    uiUtilityService: UIUtilityService,
    loaderService: LoaderService,
    $anchorScroll: angular.IAnchorScrollService,
    $location: angular.ILocationService,
    $state: angular.ui.IStateService,
    $q: angular.IQService,
    $stateParams: TopDefectsReportParams) {

    this.loaderService = loaderService;
    this.reportService = reportService;
    this.uiUtilityService = uiUtilityService;
    this.$anchorScroll = $anchorScroll;
    this.$location = $location;
    this.$state = $state;
    this.$q = $q;
    this.$stateParams = $stateParams;

    this.requirePlantSelection = true;
    this.requireShopSelection = true;

    var now = moment().add(1, 'hours').startOf('hour');
    this.uiEndDate = now.toDate();
    this.uiStartDate = now.clone().subtract(1, 'days').toDate();

    this.filters = uiUtilityService.getListOptionsFromEnum(apsEnums.TopDefectsFilter, 1);
    this.filter = apsEnums.TopDefectsFilter.Top10Defects;

    var promise = navigationService.getNavigation().then((nav) => {
      this.plants = nav.plants();
      this.selectedPlant = nav.selectedPlant;
      this.updatePlant();
      this.selectedShop = nav.selectedShop;

      return this.loadState($stateParams);
    });

    loaderService.loadingPromise(promise);

    this.scopeWorkaround = {
      defectBarClick: (defect: apsViewModels.TopNDefectReportItem): void => {
        this.generateDetailReport(defect);
      },
      formatTime: (time: Date): string => {
        return this.formatTime(time);
      }
    };

  }

  generateReport(): angular.IPromise<any> {
    if (this.form.$invalid) {
      return;
    }

    this.saveState(undefined);

    var promise = this.runReport();
    this.loaderService.loadingPromise(promise);
    return promise;
  }

  private runReport(): angular.IPromise<any> {
    this.reportShopId = this.selectedShop.id;
    this.reportShopName = this.selectedShop.name;
    this.reportStartDate = this.startDate;
    this.reportEndDate = this.endDate;
    this.reportTimeZoneId = this.selectedPlant.timeZoneId;
    this.reportFilter = this.filter;

    return this.reportService.getTopDefectsReport(
      this.reportShopId,
      this.reportStartDate,
      this.reportEndDate,
      10,
        this.filter === apsEnums.TopDefectsFilter.CriticalDefects)
      .then((defects) => {
        this.defects = defects;
        this.searchPerformed = true;
        this.detailResults = null;

        if (this.reportFilter === apsEnums.TopDefectsFilter.AllDefects) {
          return this.runDetailReport(null);
        }

        return this.$q.when();
      });
  }

  formatTime(time: Date): string {
    return DateUtilityService.formatTime(time, this.reportTimeZoneId);
  }

  updatePlant(): void {
    this.selectedShop = null;
  }

  generateDetailReport(defect: apsViewModels.TopNDefectReportItem): angular.IPromise<any> {
    var defectTypeId = defect ? defect.defectTypeId : '';

    this.saveState(defectTypeId);

    var promise = this.runDetailReport(defect);

    this.loaderService.loadingPromise(promise);

    return promise;
  }

  private runDetailReport(defect: apsViewModels.TopNDefectReportItem): angular.IPromise<any> {
    this.reportDefect = defect;

    var defectTypeId = defect ? defect.defectTypeId : '';

    return this.reportService.getDefectReportDetails(this.reportShopId,
      defectTypeId,
      this.reportStartDate,
      this.reportEndDate).then((defectDetails) => {
        this.detailResults = defectDetails;
    });
  }

  getDefectDetailsColor(): string {
    return this.uiUtilityService.getSeverityColor(this.reportDefect ? this.reportDefect.severity : 0);
  }

  loadState(params: TopDefectsReportParams): angular.IPromise<any> {
    if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
      var plant = _.find(this.plants, {id: params.reportPlantId});
      if (plant) {
        var shop = _.find(plant.shops, {id: params.reportShopId});
        if (shop) {
          this.selectedPlant = plant;
          this.selectedShop = shop;
        }
      }
    }

    if (params.startDate) {
      var startDate = moment(params.startDate);
      if (startDate.isValid()) {
        this.uiStartDate = this.startDate = startDate.toDate();
      }
    }

    if (params.endDate) {
      var endDate = moment(params.endDate);
      if (endDate.isValid()) {
        this.uiEndDate = this.endDate = endDate.toDate();
      }
    }

    if (params.filter !== undefined) {
      var filter = _.find(this.filters, { value: +params.filter }); // !!!
      if (filter) {
        this.filter = filter.value;
      }
    }

    if (params.autoRun) {
      return this.runReport().then(() => {
        var targetDefect = _.find(this.defects, { defectTypeId: params.defectTypeId });
        if (targetDefect) {
          return this.runDetailReport(targetDefect).then(() => {
            this.$location.hash('detailResultsMarker');
            this.$anchorScroll();
          });
        }
      });
    }

    return this.$q.when();
  }

  saveState(defectTypeId: string): void {
    var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
    if (reportShopId === this.$stateParams.shopId) {
      reportShopId = undefined;
    }
    var params: TopDefectsReportParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
      reportShopId: reportShopId,
      defectTypeId: defectTypeId,
      startDate: this.startDate ? this.startDate.toISOString() : undefined,
      endDate: this.endDate ? this.endDate.toISOString() : undefined,
      filter: this.filter,
      autoRun: true
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }
}

export default angular.module('aps.controller.topDefectsReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.TOP_DEFECTS_REPORT,
      url: '/admin/reports/topDefects?startDate&endDate&defectTypeId&filter&autoRun&reportPlantId&reportShopId',
      params: {
        startDate: {dynamic: true},
        endDate: {dynamic: true},
        defectTypeId: {dynamic: true},
        filter: {dynamic: true},
        autoRun: {dynamic: true},
        reportPlantId: {dynamic: true},
        reportShopId: {dynamic: true},
      },
      controller: 'TopDefectsReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Top Defects Report'
      }
    });
  })
  .controller('TopDefectsReportCtrl', TopDefectsReportCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/reports/topDefectsReport.controller.ts